import React, { useCallback, useMemo, useRef, useState, useEffect } from 'react';
import { useStore } from '../../store';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../Utils/Functions/helpers';
import SRFButton from '../Inputs/SRFButton/SRFButton';



function AuthPage() {
    const { isAuthed, isOnline, setIsAuthed, hours = 72, signIn } = useStore();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const changeUsername = useCallback((e) => setUsername(e.target.value), [setUsername]);
    const changePassword = useCallback((e) => setPassword(e.target.value), [setPassword]);
    const tryAuth = useCallback(async (e) => {
        e.preventDefault();
        const authRes = await signIn(username, password);
        if(authRes.ok) {
            navigate("/", { replace: true })
        } else {
            alert(
                (authRes?.parsedBody?.qdbapi?.errtext?.["#text"] ?? "Something went wrong") + 
                "\n\n" + 
                (authRes?.parsedBody?.qdbapi?.errdetail?.["#text"] ?? "An unexpected error occurred please contact support if the error persists.")
            );
        }
    }, [username, password])
    const navigate = useNavigate();


    useEffect(() => {
        if (isAuthed) {
            navigate("/", { replace: true })
        }
    }, [isAuthed]);


    return (
        <form className='flex flex-col items-center pt-4 gap-2' onSubmit={tryAuth}>
            <div class="lg:w-1/3 md:w-1/2 w-full px-4">
                <label htmlFor={"usernameField"} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email Address</label>
                <input value={username} autoCapitalize='off' autoComplete='email username' required onChange={changeUsername} type="text" id={`usernameField`} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"/>
            </div>
            <div class="lg:w-1/3 md:w-1/2 w-full px-4">
                <label htmlFor={"passwordField"} className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Password</label>
                <input value={password} required onChange={changePassword} type="password" id={`passwordField`} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"/>
            </div>
            <div class="lg:w-1/3 md:w-1/2 w-full px-4" >
                <SRFButton type={"submit"} color={'#face08'}>Login</SRFButton>
            </div>
            <a href={`https://atlas-titan.quickbase.com/db/main?a=ForgotPassword&what=&LoginID=${encodeURIComponent(username)}`} class="lg:w-1/3 md:w-1/2 w-full px-4 text-center text-blue-600 hover:underline" >
            I forgot my password.{/* <SRFButton type={"button"} color={'#face08'}>I forgot my password.</SRFButton><SRFButton type={"button"} color={'#face08'}>I forgot my password.</SRFButton> */}
            </a>
        </form>
    )
}

export default AuthPage;